import { Pipe, PipeTransform } from '@angular/core';

/* capitalizeFirst pipe */
@Pipe({ name: 'capitalizeFirst' })
export class CapitalizeFirstPipe implements PipeTransform {
    transform(value: string, args?: any[]): string {
        if (!value) return value;
        return value.charAt(0).toLocaleUpperCase() + value.slice(1);
    }
}
/* capitalizeFirst pipe ends */


